function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 27.9479V37.1562C13.125 37.3829 13.1865 37.6056 13.3034 37.8015C13.4203 37.9973 13.5884 38.1594 13.7904 38.2712C13.9924 38.383 14.2212 38.4404 14.4534 38.4377C14.6856 38.4349 14.9129 38.3721 15.1121 38.2556L21 34.8064L26.8866 38.2556C27.0858 38.3724 27.3132 38.4355 27.5456 38.4384C27.778 38.4413 28.0071 38.384 28.2093 38.2722C28.4115 38.1604 28.5797 37.9981 28.6967 37.8021C28.8137 37.606 28.8752 37.3831 28.875 37.1562V27.9479C26.5054 29.3656 23.7793 30.1139 21 30.1094C18.1138 30.1094 15.4179 29.3188 13.125 27.9479ZM28.875 25.625C26.6051 27.292 23.8405 28.1916 21 28.1875C17.9531 28.1919 15.0004 27.1568 12.6525 25.2611C11.1572 24.0604 9.95315 22.551 9.12705 20.8415C8.30095 19.1321 7.87335 17.2651 7.875 15.375C7.875 8.29866 13.7511 2.5625 21 2.5625C28.2489 2.5625 34.125 8.29866 34.125 15.375C34.1265 17.3643 33.6528 19.3266 32.7414 21.1059C31.8301 22.8853 30.5062 24.4326 28.875 25.625Z",
  fill: "#008C85"
});
var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 21,
  cy: 15.375,
  rx: 10.5,
  ry: 10.25,
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4989_164500)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3359 20.6068H15.5313C15.2122 20.6068 14.9061 20.483 14.6805 20.2628C14.4549 20.0425 14.3281 19.7438 14.3281 19.4323V15.3216C14.3281 15.0101 14.4549 14.7114 14.6805 14.4911C14.9061 14.2709 15.2122 14.1471 15.5313 14.1471H17.3359M21.5469 12.9727V10.6237C21.5469 10.1565 21.3567 9.70837 21.0183 9.37798C20.6799 9.04759 20.2208 8.86198 19.7422 8.86198L17.3359 14.1471V20.6068H24.1216C24.4117 20.61 24.6933 20.5107 24.9144 20.3273C25.1355 20.1438 25.2812 19.8885 25.3247 19.6085L26.1548 14.3233C26.181 14.155 26.1694 13.9831 26.1208 13.8196C26.0721 13.6561 25.9877 13.5049 25.8732 13.3764C25.7588 13.2479 25.6171 13.1453 25.458 13.0756C25.2989 13.0058 25.1261 12.9707 24.9517 12.9727H21.5469Z",
  stroke: "#008C85",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4989_164500"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.4375,
  height: 14.0938,
  fill: "white",
  transform: "translate(13.125 7.6875)"
})));
function SvgThumbsRibbon32FilledBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsRibbon32FilledBig);
export default __webpack_public_path__ + "static/media/thumbs_ribbon-32-filled-big.f39d347afe3f8a57c238b5c028dbda07.svg";
export { ForwardRef as ReactComponent };